export interface ScheduleInfo {
	name: string;
	state: string;
	expression: string | null;
	timezone: string | null;
	nextInvocationAt: string | null;
}

export function formatSchedule(info: ScheduleInfo): string {
	if (!info.expression) return "Schedule not configured";

	const rate = info.expression.match(/^rate\((\d+)\s+(\w+)\)$/);
	if (rate) {
		const n = parseInt(rate[1], 10);
		const unit = rate[2].replace(/s$/, "");
		return n === 1 ? `Every ${unit}` : `Every ${n} ${unit}s`;
	}

	return info.expression;
}

export function formatNextRun(iso: string | null): string {
	if (!iso) return "—";

	const date = new Date(iso);
	const now = Date.now();
	const diffMs = date.getTime() - now;
	const diffMin = Math.round(diffMs / 60000);

	const time = date.toLocaleTimeString([], { hour: "2-digit", minute: "2-digit" });
	if (diffMin <= 0) return `${time} (any moment)`;
	if (diffMin < 60) return `${time} (in ${diffMin} min)`;
	const hours = Math.floor(diffMin / 60);
	const mins = diffMin % 60;
	return `${time} (in ${hours}h ${mins}m)`;
}
